import { useCurrency } from "@/lib/currency";

/**
 * Display an EUR amount in the user's chosen display currency.
 * EUR is the platform's only canonical currency — Stripe charges, vendor inputs,
 * bookings, and refunds are all in EUR. This component handles display-only conversion.
 *
 * Props:
 *  - amount: number (EUR)
 *  - className: optional className
 *  - testId: optional data-testid
 */
export default function Money({ amount, className, testId }) {
  const { format } = useCurrency();
  return <span className={className} data-testid={testId}>{format(amount)}</span>;
}
